import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import CollapsibleBox from "../../../../common/collapsible/CollapsibleBox";
import { InfoBarContext } from "../../../../common/info";
import { subscribe, unsubscribe } from "../../../../eventBus";
import PdfFormError from "./PdfFormError";
import { isTouch } from "../../../../utils/screenUtil";

export const focusFieldCb = (id, cb) => {
  let field = document.querySelector(`[data-annotation-id="${id}"]`).firstChild;
  if (field) {
    field.focus();
    if (cb) {
      cb();
    }
  }
};

function PdfFormErrors({ errors }) {
  const [errorList, setErrorList] = useState(JSON.parse(errors));
  const infoBar = useContext(InfoBarContext);
  const ref = useRef(null);

  useEffect(() => {
    let subscriber = subscribe("pdf-form-errors", (data) => {
      setErrorList(data);
      if (Object.keys(data).length === 0) {
        if (infoBar.isOpen) {
          infoBar.toggle();
        }
      }
    });

    return () => unsubscribe(subscriber);
  });

  const toggleInfoBar = useCallback(() => {
    if (isTouch()) {
      infoBar.toggle();
    }
  }, [infoBar]);

  return (
    <div ref={ref} className="content">
      {Object.keys(errorList).map((name, index) => (
        <CollapsibleBox
          title={errorList[name].fieldDefinition.validationErrorMessage}
          bulmaTitleSize={6}
          key={`collapsible${index}`}
          className="has-border-left-red-6 is-size-7 mb-2"
          titleOnClick={() => focusFieldCb(errorList[name].id, toggleInfoBar)}
        >
          <PdfFormError
            key={name}
            required={errorList[name].fieldDefinition.required}
            description={errorList[name].fieldDefinition.description}
            name={errorList[name].fieldDefinition.name}
            focusFieldCb={() => focusFieldCb(errorList[name].id, toggleInfoBar)}
          />
        </CollapsibleBox>
      ))}
    </div>
  );
}

export default PdfFormErrors;
